function getCookie(name: string): string {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts?.pop()?.split(";").shift() ?? "";
  return "";
}

export const subscribeToCommunicationCenter = async (
  setLoading: (loading: boolean) => void,
  setError: (error: string) => void,
  onSuccess: any,
  apiSubscribe: string,
  close: () => void,
) => {
  setLoading(true);

  try {
    const res = await fetch(apiSubscribe, {
      headers: {
        "App-Authorization": getCookie("next-token"),
      },
    });
    const content = await res.json();
    setLoading(true);

    if (content.message === "OK") {
      setError("");
      if (onSuccess) {
        onSuccess();
      }
      close();
    } else {
      setError("Wystąpił błąd, skontaktuj się z nami, aby go rozwiązać.");
    }
  } catch {
    setLoading(false);
    setError("Wystąpił błąd, skontaktuj się z nami, aby go rozwiązać.");
  }
  setLoading(false);
};
